import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { MessageService } from 'primeng/api'

import { FunnelTasksViewService } from '../../data/services/view/funnel-tasks-view.service'
import { FUNNEL_TASK_STATE_OPTIONS, activityStateMeta } from '../../data/constants/funnel-task-state.constant'

@Component({
  selector: 'app-funnel-task-detail',
  templateUrl: './funnel-task-detail.component.html',
  styleUrls: ['./funnel-task-detail.component.scss'],
  providers: [MessageService],
})
export class FunnelTaskDetailComponent implements OnChanges {
  @Input() taskId: string | null = null
  @Input() visible = false

  @Output() visibleChange = new EventEmitter<boolean>()
  @Output() changed = new EventEmitter<boolean>()

  task$ = this.viewService.selected$
  comments$ = this.viewService.comments$
  history$ = this.viewService.history$
  loading$ = this.viewService.loading$

  stateOptions = FUNNEL_TASK_STATE_OPTIONS
  newState: string | null = null
  commentText = ''

  constructor(private viewService: FunnelTasksViewService, private messageService: MessageService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['taskId'] && this.taskId) this.viewService.loadDetail(this.taskId)
  }

  stateSeverity(state: string): string {
    return activityStateMeta(state).severity
  }

  authorName(ref: any): string {
    if (!ref || typeof ref !== 'object') return 'Usuario'
    return `${ref.names ?? ''} ${ref.lastNames ?? ''}`.trim() || 'Usuario'
  }

  submitState(): void {
    if (!this.taskId || !this.newState) return
    this.viewService.changeState(this.taskId, this.newState).subscribe((r) => {
      if (!r.error) {
        this.messageService.add({ severity: 'success', summary: 'Estado actualizado', detail: r.msg, life: 3000 })
        this.viewService.loadDetail(this.taskId!)
        this.newState = null
        this.changed.emit(true)
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: r.msg, life: 4000 })
      }
    })
  }

  submitComment(): void {
    if (!this.taskId || !this.commentText.trim()) return
    //* menciones diferidas: no hay endpoint de búsqueda de usuarios internos aún (mentions=[]).
    this.viewService.addComment(this.taskId, this.commentText.trim(), []).subscribe((r) => {
      if (!r.error) {
        this.commentText = ''
        this.viewService.refreshComments(this.taskId!)
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: r.msg, life: 4000 })
      }
    })
  }

  close(): void {
    this.viewService.clear()
    this.newState = null
    this.commentText = ''
    this.visible = false
    this.visibleChange.emit(false)
  }
}
